import { render, staticRenderFns } from "./Ajukan.vue?vue&type=template&id=385711e4&"
import script from "./Ajukan.vue?vue&type=script&lang=js&"
export * from "./Ajukan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports